import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileCta } from "@/components/site/MobileCta";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import WorksPage from "@/pages/WorksPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/usluge" element={<ServicesPage />} />
                    <Route path="/radovi" element={<WorksPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="/termin" element={<BookingPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
                <MobileCta />
            </BrowserRouter>
        </div>
    );
}

export default App;
